<template>
    <div class="main-content" v-loading="fullScreenLoading">
        <avue-crud ref="crud" :data="tableData" :table-loading="showLoading" :page.sync="page"
            @on-load="onLoad" :option="option">
            <!-- 搜索框-->
            <template #header>
                <div>
                    <div class="flex flex-wrap align-items marginBottom20">
                        <div class="flex align-items marginRight10 marginBottom10"
                            v-for="(item, index) in searchMenuList" :key="index">
                            <span class="span marginRight10 width80 textAlignRight">{{ item.label }} :
                            </span>
                            <div class="width300">
                                <el-input v-if="item.type !== 'select'" v-model="searchData[item.prop]"
                                    :placeholder="item.placeholder" clearable maxlength="50"
                                    @keyup.enter.native="handleSearch"></el-input>
                                <el-select v-else v-model="searchData[item.prop]" :placeholder="item.placeholder"
                                    clearable>
                                    <el-option v-for="option in item.options" :key="option.value" :label="option.label"
                                        :value="option.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width80 textAlignRight">触发时间 :
                            </span>
                            <div class="width300">
                                <el-date-picker v-model="searchData.triggerTime" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" :clearable="true">
                                </el-date-picker>
                            </div>
                        </div>
                        <el-button size="medium" type="primary" @click="handleSearch" style="margin-bottom: 10px"
                            class="marginLeft10">搜索</el-button>
                        <el-button size="medium" type="info" @click="handleReset" class="marginLeft10"
                            style="margin-bottom: 10px">重置</el-button>
                    </div>
                </div>
            </template>
            <!-- 操作菜单 -->
            <template slot="menu" slot-scope="{ row }">
                <el-button type="text" size="mini" @click="handleDownload(row)">源数据下载</el-button>
                <el-button type="text" size="mini" @click="handleWaveVisible(row)">查看波形</el-button>
            </template>
        </avue-crud>
        <!-- 控制器波形弹窗-->
        <wave-dialog :visible.sync="waveDialogVisible" :record-id.sync="id" :row-data="currentRowData"
            :table-data="tableData" :current-index="currentRowIndex" @close="handleWaveClose"
            @switch-record="handleSwitchRecord">
        </wave-dialog>
    </div>
</template>

<script>
import dayjs from "dayjs";
import waveDialog from "./components/waveDialog.vue";
import { waveList, waveDownload } from "@/api/collect/wave";
//import { loadList, loadDownload } from "@/api/waveform/load";
export default {
    name: "index",
    components: {
        waveDialog
    },
    data() {
        return {
            tableData: [],// 表格数据
            // 表格配置项
            option: {
                title: "",
                titleSize: "h3",
                card: false,
                border: true,
                header: false,
                stripe: false, // 显示斑马纹
                showHeader: true, // 显示表头
                index: false, // 显示索引
                indexLabel: "序号", // 索引文字
                size: "small",
                page: true, // 显示分页
                selection: false, // 显示多选框
                tip: false,
                align: "center",
                menuAlign: "center",
                menuType: "text",
                menuFixed: 'right',
                menuWidth: 280,
                editBtn: false,
                delBtn: false,
                maxHeight: 550,
                column: [
                    {
                        label: "网关地址",
                        prop: "macAddr",
                    },
                    {
                        label: "设备名称",
                        prop: "name",
                    },
                    {
                        label: "设备型号",
                        prop: "productSpecModel",
                    },
                    {
                        label: "所属用户",
                        prop: "nickname",
                    },
                    {
                        label: "所属分组",
                        prop: "groupName",
                    },
                    {
                        label: "触发时间",
                        prop: "triggerTime",
                        width: 160,
                        fixed: 'right',
                    },
                ]
            },
            showLoading: false,// 表格加载状态
            // 分页配置项
            page: {
                total: 0,
                currentPage: 1,
            },
            // 搜索数据
            searchData: {
                macAddr: "",
                triggerTime: "",
            },
            // 搜索框配置项
            searchMenuList: [
                {
                    label: "网关地址",
                    prop: "macAddr",
                    placeholder: "请输入网关地址"
                },
                {
                    label: "设备名称",
                    prop: "name",
                    placeholder: "请输入网关名称",
                },
                {
                    label: "设备型号",
                    prop: "productSpecModel",
                    placeholder: "请输入设备型号",
                },
                {
                    label: "所属用户/ID",
                    prop: "userId",
                    placeholder: "请输入所属用户名称或ID",
                },
                {
                    label: "所属分组/ID",
                    prop: "groupId",
                    placeholder: "请输入所属分组名称或ID"
                }
            ],
            waveDialogVisible: false, //波形弹窗可视标志
            id: "", //网关id
            fullScreenLoading: false, // 全屏加载状态
            currentRowData: null, // 当前选中的行数据
            currentRowIndex: -1, // 当前选中行的索引
        }
    },
    mounted() {
        this.fullScreenLoading = true;
        this.onLoad();
    },
    methods: {
        onLoad() {
            this.showLoading = true;
            const searchData = {
                ...this.searchData,
            };
            if (this.searchData.triggerTime) {
                searchData.triggerTimeStart = dayjs(
                    this.searchData.triggerTime[0]
                ).format("YYYY-MM-DD 00:00:00");
                searchData.triggerTimeEnd = dayjs(this.searchData.triggerTime[1]).format(
                    "YYYY-MM-DD 23:59:59"
                );
            }
            delete searchData.triggerTime;

            waveList({
                page: this.page.currentPage,
                size: this.page.pageSize,
                ...searchData,
            }).then((res) => {
                this.showLoading = false;
                this.fullScreenLoading = false; // 隐藏全屏加载动画
                if (res.code === 200) {
                    this.tableData = res.data.records;
                    this.page.total = res.data.total;
                }
            }).catch(() => {
                this.showLoading = false;
                this.fullScreenLoading = false; // 出错时也隐藏加载动画
            });
        },
        // 查询
        handleSearch() {
            console.log('查询数据', this.searchData)
            this.fullScreenLoading = true; // 显示全屏加载动画
            this.page.currentPage = 1;
            this.onLoad();
        },
        // 重置
        handleReset() {
            // console.log('重置')
            this.searchData = {
                macAddr: "",
                triggerTime: "",
            };
            this.page.currentPage = 1;
            this.fullScreenLoading = true; // 重置时也显示加载动画
            this.onLoad();
        },

        // 查看负载识别波形
        handleWaveVisible(row) {
            this.id = row.id;
            this.currentRowData = row; // 保存当前行数据
            this.currentRowIndex = this.tableData.findIndex(item => item.id === row.id); // 保存当前行索引
            this.waveDialogVisible = true;
        },

        // 关闭波形弹窗
        handleWaveClose() {
            this.waveDialogVisible = false;
            this.id = "";
        },

        // 下载波形数据
        async handleDownload(row) {
            this.showLoading = true;
            await waveDownload(row.id).then(response => {
            try {
                if (!(response.config.responseType === "stream")) {
                    throw new Error('下载失败：响应数据不是文件流');
                }
                // 把 JSON 对象变成字符串
                const text = JSON.stringify(response.data, null, 2);// 格式化：2个空格缩进
                // 创建一个 a 标签用于下载
                const url = window.URL.createObjectURL(new Blob([text], {type: 'text/plain;charset=utf-8'}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${row.name}识别源数据.txt`); // 设置下载文件名
                document.body.appendChild(link);
                link.click(); // 模拟点击实现下载
                document.body.removeChild(link); // 下载完成后移除元素
                window.URL.revokeObjectURL(url); // 释放 URL 对象

                this.$message({
                        message: '下载成功',
                        type: 'success'
                    });
                } catch (error) {
                    this.$message({
                        message: '下载失败，请重试',
                        type: 'error'
                    });
                }
            })
            this.showLoading = false;
        },

        // 切换记录
        handleSwitchRecord(row, index) {
            this.id = row.id;
            this.currentRowData = row;
            this.currentRowIndex = index;
        },
    }
}
</script>

<style scoped>
.fault_box_label {
    margin-right: 10px;
}
</style>